<template>
  <div v-if="profileLoading" class="profile-container">
    <PvCard class="text-center" style="width: 350px">
      <template #content>
        <i :class="ICONS.User" class="icon-loading" ></i>
        <div><strong>Loading profile...</strong></div>
      </template>
    </PvCard>
  </div>
  <PageHeader v-if="!profileLoading" />
  <HceHome v-if="!profileLoading && store.authenticated && store.user.isHceOnlyUser" />
</template>

<script setup>
import PageHeader from '../components/common/PageHeader.vue';

import { useAuthStore } from '@/stores/authStore';
import { ICONS } from '@/utils/constants';
import { computed } from 'vue';
import HceHome from '@/components/home/HceHome.vue';

const store = useAuthStore();

const profileLoading = computed(() => store.loadingProfile);

</script>

<style scoped>

.icon-loading {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.profile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Full viewport height */
  background-color: rgba(0, 0, 0, 0.5); /* Transparent overlay background */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Ensure it is above other content */
}
</style>




